import styled from 'styled-components';

import { colors, zIndexes } from '../../theme';
import { hexWithOpacity } from '../../utils';

import { StepFormCarouselVariableNames } from './constants';

export const StepFormCarouselRoot = styled.div`
  box-sizing: border-box;
  position: relative;

  display: grid;

  grid-template:
    'content' minmax(0, 1fr)
    'footer' var(${StepFormCarouselVariableNames.FooterHeight}, 0)
    / minmax(0, 1fr);

  flex: 1 1 100%;
  height: 100%;
  width: 100%;
  overflow: hidden;

  .carousel-root {
    grid-area: content;
    overflow: hidden;
    width: 100%;
    height: 100%;
  }

  .carousel.carousel-slider,
  .slider-wrapper {
    height: 100%;
  }

  .carousel .slide,
  .carousel .slider {
    height: 100%;
    text-align: unset;
  }

  li.slide > div:first-child {
    height: 100%;
  }
`;

export const StepComponentWrapper = styled.div`
  display: grid;
  place-items: center;
  overflow: auto;
`;

export const StepFormCarouselFooter = styled.div`
  position: absolute;
  box-sizing: border-box;
  z-index: ${zIndexes.actionSheet};
  bottom: 0;
  left: 0;
  width: 100%;
  box-shadow: 2px 2px 10px ${hexWithOpacity(colors.mouse, 0.3)};
`;
